import { SPACING } from './position.constants';

type Item = { id: string; pos: number };

const isInPosition = (index: number, allItems: Item[], item?: Item | null) => {
  if (!item?.id) {
    return false;
  }
  const itemAtPosition = allItems[index];
  return itemAtPosition?.id === item.id;
};

export const calculateItemPosition = <TInputItem extends Item>(
  index: number,
  allItems: TInputItem[],
  item?: Item | null,
): number => {
  const items = allItems.filter((thisItem) => item?.id !== thisItem.id);

  // if the item is in position no point in moving it around
  if (item && isInPosition(index, allItems, item)) {
    return item.pos;
  }

  const indexBounded = Math.min(Math.max(index, 0), items.length);

  if (!items.length) {
    return SPACING;
  }

  const itemPrev = items[indexBounded - 1];
  const itemNext = items[indexBounded];

  const posItemCurr = item?.pos ?? -1;
  const posItemPrev = itemPrev?.pos ?? -1;
  const posItemNext = itemNext?.pos ?? -1;

  if (posItemNext === -1) {
    // Ensure that the new pos comes after the prev card pos
    if (item && posItemCurr > posItemPrev) {
      // it's already after so no need to update
      return posItemCurr;
    } else {
      // bump it one past the last item
      return posItemPrev + SPACING;
    }
  } else {
    if (item && posItemCurr > posItemPrev && posItemCurr < posItemNext) {
      return posItemCurr;
    } else if (posItemPrev >= 0) {
      return (posItemNext + posItemPrev) / 2;
    } else {
      // halve the pos of the top item
      return posItemNext / 2;
    }
  }
};
